import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download-document",
  "use": "download-document-usage",
  "viewBox": "0 0 130 130",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130 130\" id=\"download-document\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M24 0h82a8 8 0 018 8v114a8 8 0 01-8 8H24a8 8 0 01-8-8V8a8 8 0 018-8zm0 4a4 4 0 00-4 4v114a4 4 0 004 4h82a4 4 0 004-4V8a4 4 0 00-4-4H24z\" /><path d=\"M35 32h60v4H35zm0 21h60v4H35zm0 21h60v4H35z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol